var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgDelivery = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M93.715 56.823c.075-1.515 0-8.265-5.25-8.265-.374-.62-1.865-3.72-3.208-6.337-1.193-2.48-3.878-4.064-6.787-4.064H67.358v25.347h25.76s2.014-1.24 2.014-2.686c0-1.378.373-3.582-1.417-3.995Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M88.498 48.558c5.251 0 5.167 6.599 5.092 8.114H67.233l.16-18.515h11.111c2.91 0 5.594 1.584 6.787 4.064 1.343 2.617 2.834 5.717 3.207 6.337Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m82.419 48.693-2.287-4.684c-.143-.345-.5-.551-.93-.551h-5.144v6.68h7.36c.786 0 1.358-.757 1-1.445Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M24.335 26h39.184a5 5 0 0 1 5 5v28.156H24.335V26ZM26.08 59.156h42.44v4.42H30.5a4.42 4.42 0 0 1-4.42-4.42Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M68.52 59.377H24.334M24.335 36.746V26H62.88c3.141 0 5.64 2.427 5.64 5.477v32.1H30.28c-2.64 0-3.62-1.58-3.62-4.145h-2.325v-7.919"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M43.157 64.163c0 3.26-2.755 5.837-6.14 5.837-3.386 0-6.141-2.653-6.141-5.837 0-3.183 2.755-5.836 6.14-5.836 3.465 0 6.142 2.577 6.142 5.836Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M40.323 64.163c0 1.755-1.484 3.143-3.307 3.143s-3.306-1.429-3.306-3.143c0-1.714 1.483-3.143 3.306-3.143 1.865 0 3.307 1.388 3.307 3.143Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M84.725 64.163c0 3.26-2.755 5.837-6.14 5.837-3.386 0-6.141-2.653-6.141-5.837 0-3.183 2.755-5.836 6.14-5.836 3.465 0 6.141 2.577 6.141 5.836Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M81.891 64.163c0 1.755-1.483 3.143-3.306 3.143s-3.307-1.429-3.307-3.143c0-1.714 1.484-3.143 3.307-3.143 1.865 0 3.306 1.388 3.306 3.143Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M38.113 48.263H13.03"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M24.335 40.367v7.46"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M53.334 36.846H19.96M61.623 26H19.96M15.354 26.17h-1.502M9.243 26.17H7.67M7.886 48.263H6.312M15.354 36.846h-1.502"
  }));
};
export default SvgDelivery;